export default __webpack_public_path__ + "static/media/page404.6f6a2a5f.gif";